export default {
  // English
  "en": {
    "translations": {
      "step": "Step {{step}}.",
      "timezone": "Timezone:",
      "to": "to",
      "time-timezone": "{{timezone}} time",
      "continue": "continue",
      "change": "change",
      "mobile-phone-placeholder": "Mobile phone number",
      "business-local-time": "Business local time",
      "back-to-day-selection": "Back to day selection",
      "your-selection": "Your selection",
      "confirm-booking": "press to confirm appointment",
      "request-booking": "press to request appointment",
      "confirm-reschedule": "press to reschedule appointment",
      "add-to-calendar": "Add to {{ calendar }}",
      "download-ics": "Download ICS file",
      "ok": "ok",
      "your-appointment-engine": "Your booking engine",
      "next-week": "next week",
      "previous-week": "previous week",
      "staff": "Staff",
      "privacy-policy": "Privacy collection notice",
      "no-preference": "No preference",
      "greeting": "Hello {{name}}!",
      "appointment-found": "We have found an appointment on {{date}} at {{time}}",
      "what-to-do": "What would you like to do?",
      "reschedule": "Reschedule",
      "cancel-appointment": "Cancel appointment",
      "yes": "Yes",
      "no": "No",
      "minutes": "minutes",
      "reschedule-all-future-occurrences": "Reschedule all future occurrences",
      "cancel-all-future-occurrences": "Cancel all future occurrences",
      "appointment-repeat": "This appointment will repeat",
      "daily": "daily",
      "weekly": "weekly",
      "monthly": "monthly",
      "yearly": "yearly",
      "on-weekday": "on {{weekday}}",
      "x-times": "{{count}} times",
      "indefinitely": "indefinitely",
      "next-x-occurrences": "Next {{count}} occurrences:",
      "thank-you-customer": "Thank you {{name}}!",
      "appointment-cancelled": "Your appointment has been cancelled.",
      "confirmation-sent": "We have sent you a confirmation email.",
      "next-month": "next month",
      "previous-month": "previous month",
      "other": "Other",
      "street-address": "Street address",
      "apt-unit": "Apt/Unit",
      "zip-code": "Zip Code",
    }
  },
  // German
  "de": {
    "translations": {
      "step": "Schritt {{step}}.",
      "timezone": "Zeitzone",
      "to": "bis",
      "time-timezone": "Zeit: {{timezone}}",
      "continue": "Fortsetzen",
      "change": "Ändern",
      "mobile-phone-placeholder": "Handynummer",
      "business-local-time": "Geschäftszeiten",
      "back-to-day-selection": "zurück zur Tagesauswahl",
      "your-selection": "Ihre Auswahl",
      "confirm-booking": "drücken, um den Termin zu bestätigen",
      "request-booking": "Klicken Sie, um einen Termin anzufordern",
      "confirm-reschedule": "drücken, um den Termin zu verschieben",
      "add-to-calendar": "hinzufügen {{calendar}}",
      "download-ics": "Download-Datei",
      "ok": "ok",
      "your-appointment-engine": "deine Termin-Engine",
      "next-week": "nächste Woche",
      "previous-week": "letzte Woche",
      "staff": "Mitarbeiter",
      "privacy-policy": "Datenschutz-Bestimmungen",
      "no-preference": "Keine Präferenz",
      "greeting": "Hallo {{name}}! ",
      "appointment-found": "Wir haben einen Termin am {{date}} um {{time}} gefunden",
      "what-to-do": "Was würdest du gern tun?",
      "reschedule": "Termin neu ausmachen",
      "cancel-appointment": "Termin absagen",
      "yes": "Ja",
      "no": "Nein",
      "minutes": "Minuten",
      "reschedule-all-future-occurrences": "Planen Sie alle zukünftigen Vorkommnisse neu",
      "cancel-all-future-occurrences": "Alle zukünftigen Vorkommnisse abbrechen",
      "appointment-repeat": "Dieser Termin wird wiederholt",
      "daily": "Täglich",
      "weekly": "wöchentlich",
      "monthly": "monatlich",
      "yearly": "jährlich",
      "on-weekday": "{{weekday}}",
      "x-times": "{{count}} mal",
      "indefinitely": "unbegrenzt",
      "next-x-occurrences": "Die nächsten {{count}} Ereignisse:",
      "thank-you-customer": "Danke, {{name}}!",
      "appointment-cancelled": "Ihr Termin wurde abgesagt.",
      "confirmation-sent": "Wir haben Ihnen eine Bestätigungsmail geschickt.",
      "next-month": "nächsten Monat",
      "previous-month": "vorheriger Monat",
      "other": "Andere",
      "street-address": "Adresse",
      "apt-unit": "Wohnung",
      "zip-code": "Postleitzahl",
    }
  },
  // German (informal)
  "de_informal": {
    "translations": {
      "step": "Schritt {{step}}.",
      "timezone": "Zeitzone",
      "to": "zu",
      "time-timezone": "{{timezone}} Zeit",
      "continue": "Weiter",
      "change": "ändern",
      "mobile-phone-placeholder": "Handy Nummer",
      "business-local-time": "Unsere Ortszeit",
      "back-to-day-selection": "Zurück zur Tagesauswahl",
      "your-selection": "Deine Auswahl",
      "confirm-booking": "Hier klicken um den Termin zu bestätigen",
      "request-booking": "",
      "confirm-reschedule": "Hier klicken um den Termin zu verschieben",
      "add-to-calendar": "Zum {{calendar}} hinzufügen",
      "download-ics": "ICS Datei herunterladen",
      "ok": "OK",
      "your-appointment-engine": "Deine Buchungsplattform",
      "next-week": "Nächste Woche",
      "previous-week": "Vorherige Woche",
      "staff": "Mitarbeiter",
      "privacy-policy": "Datenschutzbestimmungen",
      "no-preference": "Keine Vorlieben",
      "greeting": "Hallo {{name}}! ",
      "appointment-found": "Wir haben einen Termin am {{date}} um {{time}} gefunden.",
      "what-to-do": "Was möchtest Du machen?",
      "reschedule": "Termin verschieben",
      "cancel-appointment": "Stornieren",
      "yes": "Ja",
      "no": "Nein",
      "minutes": "Minuten",
      "reschedule-all-future-occurrences": "Planen Sie alle zukünftigen Vorkommnisse neu",
      "cancel-all-future-occurrences": "Alle zukünftigen Vorkommnisse abbrechen",
      "appointment-repeat": "Dieser Termin wird wiederholt",
      "daily": "Täglich",
      "weekly": "wöchentlich",
      "monthly": "monatlich",
      "yearly": "jährlich",
      "on-weekday": "{{weekday}}",
      "x-times": "{{count}} mal",
      "indefinitely": "unbegrenzt",
      "next-x-occurrences": "Die nächsten {{count}} Ereignisse:",
      "thank-you-customer": "Danke, {{name}}!",
      "appointment-cancelled": "Ihr Termin wurde abgesagt.",
      "confirmation-sent": "Wir haben Ihnen eine Bestätigungsmail geschickt.",
      "next-month": "Nächste Monat",
      "previous-month": "Vorherige Monat",
      "other": "Andere",
      "street-address": "Adresse",
      "apt-unit": "Wohnung",
      "zip-code": "Postleitzahl",
    }
  },
  // Russian
  "ru": {
    "translations": {
      "step": "шаг {{step}}.",
      "timezone": "часовой пояс",
      "to": "до",
      "time-timezone": "время: {{timezone}}",
      "continue": "Продолжать",
      "change": "изменение",
      "mobile-phone-placeholder": "номер мобильного телефона",
      "business-local-time": "деловое местное время",
      "back-to-day-selection": "отбор на день",
      "your-selection": "ваш выбор",
      "confirm-booking": "нажмите, чтобы подтвердить назначение",
      "request-booking": "нажмите, чтобы запросить встречу",
      "confirm-reschedule": "нажмите, чтобы перенести встречу",
      "add-to-calendar": "добавить к {{calendar}}",
      "download-ics": "Скачать файл",
      "ok": "ok",
      "your-appointment-engine": "ваш механизм назначения",
      "next-week": "Следующая неделя",
      "previous-week": "Предыдущая неделя",
      "staff": "штатный сотрудник",
      "privacy-policy": "Политика конфиденциальности",
      "no-preference": "Нет предпочтения",
      "greeting": "Привет {{name}}!",
      "appointment-found": "Мы нашли встречу на {{date}} по адресу {{time}}",
      "what-to-do": "Чем бы Вы хотели заняться?",
      "reschedule": "Перенести встречу",
      "cancel-appointment": "Отменить назначение",
      "yes": "Да",
      "no": "нет",
      "minutes": "минут",
      "reschedule-all-future-occurrences": "Перепланировать все будущие события",
      "cancel-all-future-occurrences": "Отменить все будущие события",
      "appointment-repeat": "Это назначение будет повторяться",
      "daily": "ежедневно",
      "weekly": "еженедельно",
      "monthly": "ежемесячно",
      "yearly": "раз в год",
      "on-weekday": "по {{weekday}}",
      "x-times": "{{count}} раз",
      "indefinitely": "бесконечно",
      "next-x-occurrences": "следующие {{count}} случаев:",
      "thank-you-customer": "Спасибо {{name}}!",
      "appointment-cancelled": "Ваша встреча была отменена",
      "confirmation-sent": "Мы отправили вам подтверждение по электронной почте",
      "next-month": "следующий месяц",
      "previous-month": "прошлый месяц",
      "other": "Другой",
      "street-address": "адрес улицы",
      "apt-unit": "комната",
      "zip-code": "почтовый индекс",
    }
  },
  // Spanish
  "es": {
    "translations": {
      "step": "Paso {{step}}.",
      "timezone": "Huso horario:",
      "to": "hasta",
      "time-timezone": "hora de {{timezone}}",
      "continue": "continuar",
      "change": "cambiar",
      "mobile-phone-placeholder": "Número de móvil",
      "business-local-time": "Hora local del negocio",
      "back-to-day-selection": "Volver a seleccionar día",
      "your-selection": "Su selección",
      "confirm-booking": "clic para confirmar reserva",
      "request-booking": "clic para solicitar cita",
      "confirm-reschedule": "clic para confirmar el cambio",
      "add-to-calendar": "Agregar a {{ calendar }}",
      "download-ics": "Descargar archivo ICS",
      "ok": "ok",
      "your-appointment-engine": "Su motor de citas",
      "next-week": "próxima semana",
      "previous-week": "semana anterior",
      "staff": "Miembro del equipo",
      "privacy-policy": "Política de privacidad",
      "no-preference": "Sin preferencias",
      "greeting": "Hola {{name}}!",
      "appointment-found": "Hemos encontrado una cita el {{date}} a las {{time}}",
      "what-to-do": "Que te gustaría hacer?",
      "reschedule": "Reagendar",
      "cancel-appointment": "Cancelar cita",
      "yes": "Si",
      "no": "No",
      "minutes": "minutos",
      "reschedule-all-future-occurrences": "Reagendar todas las ocurrencias futuras",
      "cancel-all-future-occurrences": "Cancelar todas las ocurrencias futuras",
      "appointment-repeat": "Esta cita se repetirá",
      "daily": "diariamente",
      "weekly": "semanalmente",
      "monthly": "mensualmente",
      "yearly": "anualmente",
      "on-weekday": "los {{weekday}}",
      "x-times": "{{count}} veces",
      "indefinitely": "indefinidamente",
      "next-x-occurrences": "Siguientes {{count}} ocurrencias:",
      "thank-you-customer": "Gracias {{name}}!",
      "appointment-cancelled": "Su cita ha sido cancelada.",
      "confirmation-sent": "Te hemos enviado un correo electrónico de confirmación.",
      "next-month": "próximo mes",
      "previous-month": "mes anterior",
      "other": "Otro",
      "street-address": "Dirección",
      "apt-unit": "Apt",
      "zip-code": "Código postal",
    }
  },
  // French
  "fr": {
    "translations": {
      "step": "étape {{step}}.",
      "timezone": "fuseau horaire",
      "to": "à",
      "time-timezone": "fuseau: {{timezone}}",
      "continue": "continuer",
      "change": "changer",
      "mobile-phone-placeholder": "numéro de téléphone portable",
      "business-local-time": "heure locale des affaires",
      "back-to-day-selection": "retour à la sélection du jour",
      "your-selection": "votre sélection",
      "confirm-booking": "cliquez ici pour confirmer le rendez-vous",
      "request-booking": "cliquer pour demander un rendez-vous",
      "confirm-reschedule": "appuyer pour reporter le rendez-vous",
      "add-to-calendar": "Ajouter au {{calendar}}",
      "download-ics": "Télécharger le fichier ICS",
      "ok": "ok",
      "your-appointment-engine": "votre moteur de rendez-vous",
      "next-week": "prochaine semaine",
      "previous-week": "semaine précédente",
      "staff": "Intervenant",
      "privacy-policy": "Politique de confidentialité",
      "no-preference": "Pas de préférence",
      "greeting": "Bonjour {{name}}",
      "appointment-found": "Nous avons trouvé un rendez-vous le {{date}} à {{time}}",
      "what-to-do": "Qu'est-ce que vous souhaitez faire ?",
      "reschedule": "Re-planifier un rendez-vous",
      "cancel-appointment": "Annuler un rendez-vous",
      "yes": "Oui",
      "no": "Non",
      "minutes": "minutes",
      "reschedule-all-future-occurrences": "Replanifier toutes les occurrences futures",
      "cancel-all-future-occurrences": "Annuler toutes les occurrences futures",
      "appointment-repeat": "Ce rendez-tu va répéter",
      "daily": "du quotidien",
      "weekly": "hebdomadaire",
      "monthly": "mensuel",
      "yearly": "annuel",
      "on-weekday": "le {{weekday}}",
      "x-times": "{{count}} fois",
      "indefinitely": "indéfiniment",
      "next-x-occurrences": "{{count}} prochaines occurrences:",
      "thank-you-customer": "Merci {{name}}!",
      "appointment-cancelled": "Votre rendez-vous a été annulé.",
      "confirmation-sent": "Nous vous avons envoyé un e-mail de confirmation.",
      "next-month": "le mois prochain",
      "previous-month": "le mois précédent",
      "other": "Autre",
      "street-address": "addresse",
      "apt-unit": "appartement",
      "zip-code": "code postal",
    }
  },
  // Japanese
  "ja": {
    "translations": {
      "step": "ステップ {{step}}.",
      "timezone": "タイムゾーン",
      "to": "〜まで",
      "time-timezone": "時間: {{timezone}}",
      "continue": "持続する",
      "change": "変化する",
      "mobile-phone-placeholder": "携帯電話番号",
      "business-local-time": "ビジネス現地時間",
      "back-to-day-selection": "日の選択に戻る",
      "your-selection": "あなたの選択",
      "confirm-booking": "ご予約確認",
      "request-booking": "クリックして予約をリクエスト",
      "confirm-reschedule": "ご予約変更",
      "add-to-calendar": "追加 {{calendar}}",
      "download-ics": "ダウンロードファイル",
      "ok": "ok",
      "your-appointment-engine": "あなたの予約エンジン",
      "next-week": "来週",
      "previous-week": "前の週",
      "staff": "職員",
      "privacy-policy": "個人情報保護方針",
      "no-preference": "指定なし",
      "greeting": "{{name}}様　ご予約変更ページ",
      "appointment-found": "現在、 {{date}} {{time}}にてご予約を承っております。",
      "what-to-do": "ご予約を変更されますか？",
      "reschedule": "予約変更をする",
      "cancel-appointment": "予約のキャンセルをする",
      "yes": "はい",
      "no": "いいえ",
      "minutes": "分",
      "reschedule-all-future-occurrences": "将来のすべての予定を再スケジュールする",
      "cancel-all-future-occurrences": "将来のすべてのキャンセルをキャンセルする",
      "appointment-repeat": "この予定は繰り返されます",
      "daily": "毎日",
      "weekly": "毎週",
      "monthly": "毎月",
      "yearly": "毎年",
      "on-weekday": "{{weekday}}",
      "x-times": "{{count}}回",
      "indefinitely": "無限に",
      "next-x-occurrences": "次の{{count}}回の出現:",
      "thank-you-customer": "{{name}}様　ありがとうございました。",
      "appointment-cancelled": "ご予約がキャンセルされました。",
      "confirmation-sent": "確認メールを送信しました",
      "next-month": "来月",
      "previous-month": "前月",
      "other": "その他の",
      "street-address": "アドレス",
      "apt-unit": "アパート",
      "zip-code": "郵便番号",
    }
  },
  // Portuguese
  "pt": {
    "translations": {
      "step": "degrau {{step}}.",
      "timezone": "fuso horário",
      "to": "até",
      "time-timezone": "Tempo: {{timezone}}",
      "continue": "continuar",
      "change": "mudança",
      "mobile-phone-placeholder": "número de celular",
      "business-local-time": "horário local de negócios",
      "back-to-day-selection": "de volta à seleção do dia",
      "your-selection": "sua seleção",
      "confirm-booking": "pressione para confirmar o compromisso",
      "request-booking": "clique para solicitar compromisso",
      "confirm-reschedule": "pressione para reprogramar compromisso",
      "add-to-calendar": "adicionar à {{calendar}}",
      "download-ics": "⇬ Fazer download do arquivo",
      "ok": "ok",
      "your-appointment-engine": "seu mecanismo de agendamento",
      "next-week": "semana que vem",
      "previous-week": "semana anterior",
      "staff": "Membro da equipe",
      "privacy-policy": "Política de Privacidade",
      "no-preference": "Sem preferência",
      "greeting": "Olá {{name}}",
      "appointment-found": "Encontrámos um encontro em {{date}} às {{time}}",
      "what-to-do": "O que você gostaria de fazer?",
      "reschedule": "Reagendar compromisso",
      "cancel-appointment": "Cancela o agendamento",
      "yes": "Sim",
      "no": "Não",
      "minutes": "minutos",
      "reschedule-all-future-occurrences": "Reprogramar todas as ocorrências futuras",
      "cancel-all-future-occurrences": "Cancelar todas as ocorrências futuras",
      "appointment-repeat": "Este compromisso será repetido",
      "daily": "diariamente",
      "weekly": "semanal",
      "monthly": "por mês",
      "yearly": "anual",
      "on-weekday": "nas {{weekday}}",
      "x-times": "{{count}} vezes",
      "indefinitely": "indefinidamente",
      "next-x-occurrences": "Próximos {{count}} ocorrências:",
      "thank-you-customer": "Obrigado {{name}}!",
      "appointment-cancelled": "Seu compromisso foi cancelado.",
      "confirmation-sent": "Nós lhe enviamos um email de confirmação.",
      "next-month": "próximo mês",
      "previous-month": "mês anterior",
      "other": "Outro",
      "street-address": "endereço",
      "apt-unit": "apartamento",
      "zip-code": "código postal",
    }
  },
  // Italian
  "it": {
    "translations": {
      "step": "passo {{step}}.",
      "timezone": "fuso orario",
      "to": "fino a",
      "time-timezone": "fuso orario: {{timezone}}",
      "continue": "Continua",
      "change": "modifica",
      "mobile-phone-placeholder": "numero di cellulare",
      "business-local-time": "ora locale d'affari",
      "back-to-day-selection": "torna alla selezione del giorno",
      "your-selection": "la tua selezione",
      "confirm-booking": "premere per confermare l'appuntamento",
      "request-booking": "fai clic per richiedere un appuntamento",
      "confirm-reschedule": "premere per riprogrammare l'appuntamento",
      "add-to-calendar": "aggiungere a {{calendar}}",
      "download-ics": "download file",
      "ok": "ok",
      "your-appointment-engine": "il tuo motore per gli appuntamenti",
      "next-week": "la prossima settimana",
      "previous-week": "la settimana precedente",
      "staff": "Membro del personale",
      "privacy-policy": "Politica sulla riservatezza",
      "no-preference": "Nessuna preferenza",
      "greeting": "Ciao {{name}}!",
      "appointment-found": "Abbiamo trovato un appuntamento il {{date}} a {{time}}",
      "what-to-do": "Cosa ti piacerebbe fare?",
      "reschedule": "Riprogrammare l'appuntamento",
      "cancel-appointment": "Annulla l'appuntamento",
      "yes": "Si",
      "no": "No",
      "minutes": "minuti",
      "reschedule-all-future-occurrences": "Ripianificare tutte le occorrenze future",
      "cancel-all-future-occurrences": "Annulla tutte le occorrenze future",
      "appointment-repeat": "Questo appuntamento si ripeterà",
      "daily": "quotidiano",
      "weekly": "settimanalmente",
      "monthly": "mensile",
      "yearly": "annuale",
      "on-weekday": "il {{weekday}}",
      "x-times": "{{count}} volte",
      "indefinitely": "indefinitamente",
      "next-x-occurrences": "Prossimi {{count}} eventi:",
      "thank-you-customer": "Grazie {{name}}!",
      "appointment-cancelled": "Il tuo appuntamento è stato cancellato.",
      "confirmation-sent": "Ti abbiamo inviato una email di conferma.",
      "next-month": "il prossimo mese",
      "previous-month": "il mese scorso",
      "other": "Altro",
      "street-address": "indirizzo",
      "apt-unit": "appartamento",
      "zip-code": "codice postale",
    }
  },
  // Persian
  "fa": {
    "translations": {
      "step": "گام {{step}}.",
      "timezone": "منطقه زمانی",
      "to": "تا زمانه",
      "time-timezone": "زمان: {{timezone}}",
      "continue": "ادامه هید",
      "change": "تغییر دادن",
      "mobile-phone-placeholder": "شماره موبایل",
      "business-local-time": "زمان محلی کسب و کار",
      "back-to-day-selection": "بازگشت به انتخاب روز",
      "your-selection": "انتخاب شما",
      "confirm-booking": "مطبوعات برای تایید قرار ملاقات",
      "request-booking": "برای درخواست قرار ملاقات کلیک کنید",
      "confirm-reschedule": "فشار برای بازنشستگی قرار ملاقات",
      "add-to-calendar": "اضافه کردن به {{calendar}}",
      "download-ics": "دریافت فایل",
      "ok": "خوب",
      "your-appointment-engine": "موتور انتصاب شما",
      "next-week": "هفته بعد",
      "previous-week": "هفته گذشته",
      "staff": "کارمند عضو",
      "privacy-policy": "سیاست حفظ حریم خصوصی",
      "no-preference": "بدون اولویت",
      "greeting": "سلام!",
      "appointment-found": "ما یک قرار ملاقات در {{date}} در ساعت {{time}} پیدا کردیم",
      "what-to-do": "چه کاری دوست داری انجام دهید؟",
      "reschedule": "مجدد برنامه",
      "cancel-appointment": "لغو",
      "yes": "بله",
      "no": "خیر",
      "minutes": "دقیقه",
      "reschedule-all-future-occurrences": "همه رویدادهای آینده را دوباره تنظیم کنید",
      "cancel-all-future-occurrences": "لغو تمام وقایع آینده",
      "appointment-repeat": "این انتصاب تکرار خواهد شد",
      "daily": "روزانه",
      "weekly": "هفتگی",
      "monthly": "ماهانه",
      "yearly": "سالانه",
      "on-weekday": "{{weekday}} در",
      "x-times": "{{count}} بار",
      "indefinitely": " طور نامحدود",
      "next-x-occurrences": "{{count}} رخداد بعدی:",
      "thank-you-customer": "{{name}} ممنون",
      "appointment-cancelled": "قرار ملاقات شما لغو شده است",
      "confirmation-sent": "ما یک ایمیل تأیید ارسال کردیم",
      "next-month": "ماه بعد",
      "previous-month": "ماه گذشته",
      "other": "دیگر",
      "street-address": "نشانی",
      "apt-unit": "اپارتمان",
      "zip-code": "کد پستی",
    }
  },
  // Chinese
  "zh": {
    "translations": {
      "step": "步 {{step}}.",
      "timezone": "时区",
      "to": "直到",
      "time-timezone": "时间: {{timezone}}",
      "continue": "继续",
      "change": "更改",
      "mobile-phone-placeholder": "手机号码",
      "business-local-time": "当地时间",
      "back-to-day-selection": "回到日常选择",
      "your-selection": "你的选择",
      "confirm-booking": "按确认预约",
      "request-booking": "点击申请预约",
      "confirm-reschedule": "按下以重新安排预约",
      "add-to-calendar": "添加 {{calendar}}",
      "download-ics": "下载文件",
      "ok": "好",
      "your-appointment-engine": "你的预约引擎",
      "next-week": "下周",
      "previous-week": "上个礼拜",
      "staff": "工作人员",
      "privacy-policy": "隐私政策",
      "no-preference": "没有偏好",
      "greeting": "你好 {{name}}!",
      "appointment-found": "我们在{{date}}日{{time}}找到了预约",
      "what-to-do": "你想干什么？",
      "reschedule": "重新安排预约",
      "cancel-appointment": "取消预约",
      "yes": "是",
      "no": "否",
      "minutes": "分钟",
      "reschedule-all-future-occurrences": "重新安排所有未来的事件",
      "cancel-all-future-occurrences": "取消所有将来发生的事件",
      "appointment-repeat": "这个任命将重复",
      "daily": "日常",
      "weekly": "每周",
      "monthly": "每月一次",
      "yearly": "每年",
      "on-weekday": "{{weekday}}",
      "x-times": "{{count}} 倍",
      "indefinitely": "无限期",
      "next-x-occurrences": "接下来的{{count}}次事件:",
      "thank-you-customer": "谢谢{{name}}！",
      "appointment-cancelled": "您的预约已被取消。",
      "confirmation-sent": "我们已向您发送确认电子邮件",
      "next-month": "下个月",
      "previous-month": "前一个月",
      "other": "其他",
      "street-address": "地址",
      "apt-unit": "公寓",
      "zip-code": "邮编",
    }
  },
  // Polish
  "pl": {
    "translations": {
      "step": "krok {{step}}.",
      "timezone": "strefa czasowa",
      "to": "aż do",
      "time-timezone": "czas: {{timezone}}",
      "continue": "dalej",
      "change": "zmiana",
      "mobile-phone-placeholder": "numer telefonu komórkowego",
      "business-local-time": "czas lokalny",
      "back-to-day-selection": "powrót do wyboru dnia",
      "your-selection": "twój wybór",
      "confirm-booking": "naciśnij, aby potwierdzić spotkanie",
      "request-booking": "kliknij, aby poprosić o spotkanie",
      "confirm-reschedule": "naciśnij, aby zmienić termin spotkania",
      "add-to-calendar": "dodać do {{calendar}}",
      "download-ics": "pobieranie pliku",
      "ok": "ok",
      "your-appointment-engine": "twój silnik spotkania",
      "next-week": "w następnym tygodniu",
      "previous-week": "Poprzedni tydzień",
      "staff": "obsługa",
      "privacy-policy": "Polityka prywatności",
      "no-preference": "Bez preferencji",
      "greeting": "Cześć {{name}}!",
      "appointment-found": "Znaleźliśmy spotkanie w dniu {{date}} o {{time}}",
      "what-to-do": "Co chciałbyś robić?",
      "reschedule": "zmień termin spotkania",
      "cancel-appointment": "odwołać spotkanie",
      "yes": "Tak",
      "no": "nie",
      "minutes": "minut",
      "reschedule-all-future-occurrences": "Zmień harmonogram wszystkich przyszłych zdarzeń",
      "cancel-all-future-occurrences": "Anuluj wszystkie przyszłe wystąpienia",
      "appointment-repeat": "To spotkanie się powtórzy",
      "daily": "codziennie",
      "weekly": "co tydzień",
      "monthly": "miesięczny",
      "yearly": "rocznie",
      "on-weekday": "w {{weekday}}",
      "x-times": "{{count}} razy",
      "indefinitely": "w sposób nieokreślony",
      "next-x-occurrences": "Kolejne {{count}} wystąpień:",
      "thank-you-customer": "Dziękuję {{name}}!",
      "appointment-cancelled": "Twoje spotkanie zostało anulowane",
      "confirmation-sent": "Wysłaliśmy Ci wiadomość e-mail z potwierdzeniem",
      "next-month": "w następnym miesiącu",
      "previous-month": "Poprzedni miesiac",
      "other": "Inny",
      "street-address": "adres",
      "apt-unit": "mieszkanie",
      "zip-code": "kod pocztowy",
    }
  },
  // Dutch
  "nl": {
    "translations": {
      "step": "stap {{step}}.",
      "timezone": "tijdzone",
      "to": "tot",
      "time-timezone": "tijd: {{timezone}}",
      "continue": "doorgaan",
      "change": "aanpassen",
      "mobile-phone-placeholder": "mobiele telefoonnummer",
      "business-local-time": "zakelijke lokale tijd",
      "back-to-day-selection": "selectie van de dag",
      "your-selection": "uw selectie",
      "confirm-booking": "Klik hier om de afspraak te bevestigen",
      "request-booking": "Klik om een ​​afspraak aan te vragen",
      "confirm-reschedule": "druk op om de afspraak opnieuw te plannen",
      "add-to-calendar": "Toevoegen aan {{calendar}}",
      "download-ics": "Download ICS bestand",
      "ok": "ok",
      "your-appointment-engine": "je afspraakmachine",
      "next-week": "volgende week",
      "previous-week": "vorige week",
      "staff": "medewerker",
      "privacy-policy": "Privacybeleid",
      "no-preference": "Geen voorkeur",
      "greeting": "Hallo {{name}}!",
      "appointment-found": "We hebben een afspraak gevonden op {{date}} om {{time}}",
      "what-to-do": "Wat zou je willen doen?",
      "reschedule": "Afspraak verzetten",
      "cancel-appointment": "Afspraak afzeggen",
      "yes": "Ja",
      "no": "nee",
      "minutes": "minuten",
      "reschedule-all-future-occurrences": "Breng alle toekomstige gebeurtenissen opnieuw in kaart",
      "cancel-all-future-occurrences": "Annuleer alle toekomstige voorvallen",
      "appointment-repeat": "Deze afspraak zal worden herhaald",
      "daily": "dagelijks",
      "weekly": "wekelijks",
      "monthly": "maandelijks",
      "yearly": "jaar-",
      "on-weekday": "op {{weekday}}",
      "x-times": "{{count}} keer",
      "indefinitely": "voor onbepaalde tijd",
      "next-x-occurrences": "Volgende {{count}} instanties:",
      "thank-you-customer": "Bedankt {{name}}!",
      "appointment-cancelled": "Je afspraak is geannuleerd.",
      "confirmation-sent": "We hebben je een bevestigingsmail gestuurd.",
      "next-month": "volgende maand",
      "previous-month": "vorige maand",
      "other": "Andere",
      "street-address": "adres",
      "apt-unit": "appartement",
      "zip-code": "postcode",
    }
  },
  // Turkish
  "tr": {
    "translations": {
      "step": "adım {{step}}.",
      "timezone": "saat dilimi",
      "to": "a kadar",
      "time-timezone": "zaman: {{timezone}}",
      "continue": "devam et",
      "change": "değişiklik",
      "mobile-phone-placeholder": "cep telefonu numarası",
      "business-local-time": "iş yerel saati",
      "back-to-day-selection": "gün seçimine geri dön",
      "your-selection": "senin seçimin",
      "confirm-booking": "randevuyu onaylamak için basın",
      "request-booking": "randevu almak için tıklayın",
      "confirm-reschedule": "randevuyu yeniden planlamak için basın",
      "add-to-calendar": "a ekle {{calendar}}",
      "download-ics": "dosyayı indir",
      "ok": "tamam",
      "your-appointment-engine": "randevu motorunuz",
      "next-week": "gelecek hafta",
      "previous-week": "önceki hafta",
      "staff": "Personel",
      "privacy-policy": "Gizlilik Politikası",
      "no-preference": "Tercih yok",
      "greeting": "Merhaba {{name}}!",
      "appointment-found": "{{date}} {{time}} 'da randevu aldık",
      "what-to-do": "Ne yapmak istersin?",
      "reschedule": "Yeniden zamanlama randevusu",
      "cancel-appointment": "Randevu iptal",
      "yes": "Evet",
      "no": "Hayır",
      "minutes": "dakika",
      "reschedule-all-future-occurrences": "Gelecekteki tüm olayları yeniden planla",
      "cancel-all-future-occurrences": "Gelecekteki tüm olayları iptal et",
      "appointment-repeat": "Bu randevu tekrarlanacak",
      "daily": "günlük",
      "weekly": "haftalık",
      "monthly": "aylık",
      "yearly": "yıllık",
      "on-weekday": "{{weekday}}",
      "x-times": "{{count}} kere",
      "indefinitely": "süresiz olarak",
      "next-x-occurrences": "Gelecek {{count}} olay:",
      "thank-you-customer": "Teşekkürler {{name}}!",
      "appointment-cancelled": "Randevunuz iptal edildi.",
      "confirmation-sent": "Size bir onay e-postası gönderdik.",
      "next-month": "gelecek ay",
      "previous-month": "geçtiğimiz ay",
      "other": "Diğer",
      "street-address": "adres",
      "apt-unit": "daire",
      "zip-code": "posta kodu",
    }
  },
  // Czech
  "cs": {
    "translations": {
      "step": "krok {{step}}.",
      "timezone": "časové pásmo",
      "to": "až do",
      "time-timezone": "čas: {{timezone}}",
      "continue": "pokračovat",
      "change": "změna",
      "mobile-phone-placeholder": "Číslo mobilního telefonu",
      "business-local-time": "obchodní místní čas",
      "back-to-day-selection": "zpět k dennímu výběru",
      "your-selection": "Váš výběr",
      "confirm-booking": "stisknutím tlačítka potvrďte schůzku",
      "request-booking": "kliknutím si vyžádejte schůzku",
      "confirm-reschedule": "stisknutím tlačítka změňte schůzku",
      "add-to-calendar": "přidat do {{calendar}}",
      "download-ics": "stáhnout soubor",
      "ok": "ok",
      "your-appointment-engine": "váš jmenovací motor",
      "next-week": "příští týden",
      "previous-week": "minulý týden",
      "staff": "Zaměstnanec",
      "privacy-policy": "Zásady ochrany osobních údajů",
      "no-preference": "Žádná preference",
      "greeting": "Dobrý den {{name}}!",
      "appointment-found": "Nalezli jsme schůzku dne {{date}} v {{time}} *",
      "what-to-do": "Co bys rád dělal?",
      "reschedule": "Změna schůzky",
      "cancel-appointment": "Zrušit schůzku",
      "yes": "Ano",
      "no": "ne",
      "minutes": "minut",
      "reschedule-all-future-occurrences": "Změňte všechny budoucí výskyty",
      "cancel-all-future-occurrences": "Zrušte všechny budoucí výskyty",
      "appointment-repeat": "Toto jmenování se bude opakovat",
      "daily": "denně",
      "weekly": "týdně",
      "monthly": "měsíční",
      "yearly": "roční",
      "on-weekday": "v {{weekday}}",
      "x-times": "{{count}} krát",
      "indefinitely": "na neurčito",
      "next-x-occurrences": "Dalších {{count}} výskytů:",
      "thank-you-customer": "Děkuji {{name}}!",
      "appointment-cancelled": "Vaše schůzka byla zrušena.",
      "confirmation-sent": "Poslali jsme vám potvrzovací e-mail.",
      "next-month": "příští měsíc",
      "previous-month": "předchozí měsíc",
      "other": "jiný",
      "street-address": "adresa",
      "apt-unit": "apartmán",
      "zip-code": "PSČ",
    }
  },
  // Korean
  "ko": {
    "translations": {
      "step": "단계 {{step}}.",
      "timezone": "시간대",
      "to": "...까지",
      "time-timezone": "시각: {{timezone}}",
      "continue": "잇다",
      "change": "변화",
      "mobile-phone-placeholder": "휴대 전화 번호",
      "business-local-time": "사업 현지 시간",
      "back-to-day-selection": "백 투데이 선택",
      "your-selection": "당신의 선택",
      "confirm-booking": "약속을 확인하기 위해 눌러라.",
      "request-booking": "약속을 요청하려면 클릭",
      "confirm-reschedule": "약속을 다시 예약하려면 누르십시오.",
      "add-to-calendar": "에 추가하다 {{calendar}}",
      "download-ics": "파일 다운로드",
      "ok": "승인",
      "your-appointment-engine": "약속 엔진",
      "next-week": "다음주",
      "previous-week": "지난주",
      "staff": "직원",
      "privacy-policy": "개인 정보 정책",
      "no-preference": "선호도 없음",
      "greeting": "안녕하세요 {{name}}!",
      "appointment-found": "{{date}} * {{time}} *에 약속을 발견했습니다",
      "what-to-do": "무엇을하고 싶으십니까?",
      "reschedule": "약속 재 지정",
      "cancel-appointment": "약속 취소",
      "yes": "예",
      "no": "아니오",
      "minutes": "분",
      "reschedule-all-future-occurrences": "모든 향후 발생 일정 조정",
      "cancel-all-future-occurrences": "향후 발생하는 모든 작업 취소",
      "appointment-repeat": "이 약속은 반복 될 것입니다.",
      "daily": "매일",
      "weekly": "주간",
      "monthly": "월간 간행물",
      "yearly": "매년",
      "on-weekday": "{{weekday}}",
      "x-times": "{{count}} 번",
      "indefinitely": "무기한으로",
      "next-x-occurrences": "다음 {{count}} 번 발생:",
      "thank-you-customer": "{{name}} 감사합니다!",
      "appointment-cancelled": "약속이 취소되었습니다.",
      "confirmation-sent": "확인 이메일을 보냈습니다.",
      "next-month": "다음 달",
      "previous-month": "지난달",
      "other": "다른",
      "street-address": "주소",
      "apt-unit": "아파트",
      "zip-code": "우편 번호",
    }
  },
  // Arabic
  "ar": {
    "translations": {
      "step": "خطوة {{step}}.",
      "timezone": "وحدة زمنية",
      "to": "حتى",
      "time-timezone": "زمن: {{timezone}}",
      "continue": "استمر",
      "change": "يتغيرون",
      "mobile-phone-placeholder": "رقم الهاتف الجوال",
      "business-local-time": "وقت العمل المحلي",
      "back-to-day-selection": "العودة إلى يوم الاختيار",
      "your-selection": "اختيارك",
      "confirm-booking": "اضغط لتأكيد الموعد",
      "request-booking": "انقر لطلب موعد",
      "confirm-reschedule": "اضغط لإعادة جدولة موعد",
      "add-to-calendar": "اضف إليه {{calendar}}",
      "download-ics": "تحميل الملف",
      "ok": "ok",
      "your-appointment-engine": "محرك التعيين الخاص بك",
      "next-week": "الاسبوع القادم",
      "previous-week": "الاسبوع السابق",
      "staff": "موظف",
      "privacy-policy": "سياسة الخصوصية",
      "no-preference": "بدون تفضيل",
      "greeting": "مرحبا!",
      "appointment-found":"{{date}} {{time}} موعد",
      "what-to-do": "ماذا تريد ان تفعل؟",
      "reschedule": "إعادة جدولة",
      "cancel-appointment": "إلغاء",
      "yes": "نعم",
      "no": "لا",
      "minutes": "دقيقة",
      "reschedule-all-future-occurrences": "إعادة جدولة جميع الأحداث المستقبلية",
      "cancel-all-future-occurrences": "إلغاء جميع التكرارات المستقبلية",
      "appointment-repeat": "هذا التعيين سوف يتكرر",
      "daily": "اليومي",
      "weekly": "أسبوعي",
      "monthly": "شهريا",
      "yearly": "سنوي",
      "on-weekday": "{{weekday}}",
      "x-times": "{{count}} مرات",
      "indefinitely": "غير مسمى",
      "next-x-occurrences": "التواجد {{count}} التالي:",
      "thank-you-customer": "شكرا لك {{name}}!",
      "appointment-cancelled": "تم إلغاء موعدك.",
      "confirmation-sent": "لقد ارسلنا اليك ايميل تاكيد",
      "next-month": "الشهر القادم",
      "previous-month": "الشهر الماضى",
      "other": "آخر",
      "street-address": "عنوان",
      "apt-unit": "جناح / شقة",
      "zip-code": "الرمز البريدي",
    }
  },
  // Vietnamese
  "vi": {
    "translations": {
      "step": "bậc thang {{step}}.",
      "timezone": "Múi giờ",
      "to": "cho đến",
      "time-timezone": "thời gian: {{timezone}}",
      "continue": "tiếp tục",
      "change": "thay đổi",
      "mobile-phone-placeholder": "số điện thoại",
      "business-local-time": "giờ địa phương",
      "back-to-day-selection": "trở lại lựa chọn ngày",
      "your-selection": "Lựa chọn của bạn",
      "confirm-booking": "nhấn để xác nhận cuộc hẹn",
      "request-booking": "bấm vào để yêu cầu cuộc hẹn",
      "confirm-reschedule": "nhấn để lên lịch lại cuộc hẹn",
      "add-to-calendar": "thêm vào {{calendar}}",
      "download-ics": "Tải tập tin",
      "ok": "được",
      "your-appointment-engine": "công cụ đặt chỗ của bạn",
      "next-week": "tuần tới",
      "previous-week": "tuần trước",
      "staff": "Nhân viên",
      "privacy-policy": "Chính sách bảo mật",
      "no-preference": "Không có tùy chọn",
      "greeting": "Xin chào * Sebastian *!",
      "appointment-found": "Chúng tôi đã tìm thấy cuộc hẹn vào {{date}} tại {{time}}",
      "what-to-do": "Bạn thích làm gì? ",
      "reschedule": "Lên lịch hẹn",
      "cancel-appointment": "Hủy cuộc hẹn",
      "yes": "Có",
      "no": "không",
      "minutes": "phút",
      "reschedule-all-future-occurrences": "Sắp xếp lại tất cả các lần xuất hiện trong tương lai",
      "cancel-all-future-occurrences": "Hủy bỏ tất cả các lần xuất hiện trong tương lai",
      "appointment-repeat": "Cuộc hẹn này sẽ lặp lại",
      "daily": "hằng ngày",
      "weekly": "hàng tuần",
      "monthly": "hàng tháng",
      "yearly": "hàng năm",
      "on-weekday": "{{weekday}}",
      "x-times": "{{count}} lần",
      "indefinitely": "vô thời hạn",
      "next-x-occurrences": "{{count}} lần xuất hiện tiếp theo:",
      "thank-you-customer": "Cảm ơn bạn {{name}}!",
      "appointment-cancelled": "Cuộc hẹn của bạn đã bị hủy bỏ.",
      "confirmation-sent": "Chúng tôi đã gửi cho bạn một email xác nhận.",
      "next-month": "tháng tiếp theo",
      "previous-month": "tháng trước",
      "other": "Khác",
      "street-address": "Địa chỉ",
      "apt-unit": "căn hộ",
      "zip-code": "mã bưu điện",
    }
  },
  // Swedish
  "sv": {
    "translations": {
      "step": "steg {{step}}.",
      "timezone": "tidszon",
      "to": "fram tills",
      "time-timezone": "tid: {{timezone}}",
      "continue": "Fortsätta",
      "change": "Byta",
      "mobile-phone-placeholder": "mobilnummer",
      "business-local-time": "företag lokal tid",
      "back-to-day-selection": "val till dag till dag",
      "your-selection": "ditt val",
      "confirm-booking": "tryck för att bekräfta mötet",
      "request-booking": "tryck för att begära en tid",
      "confirm-reschedule": "tryck för att omorganisera mötet",
      "add-to-calendar": "Lägg till {{calendar}}",
      "download-ics": "nedladdning fil",
      "ok": "ok",
      "your-appointment-engine": "din mötesmotor",
      "next-week": "nästa vecka",
      "previous-week": "förra veckan",
      "staff": "anställd",
      "privacy-policy": "Integritetspolicy",
      "no-preference": "Ingen preferens",
      "greeting": "Hej {{name}}!",
      "appointment-found": "Vi har hittat ett möte på {{date}} vid {{time}}",
      "what-to-do": "Vad skulle du vilja göra?",
      "reschedule": "Boka om möte",
      "cancel-appointment": "Avbryt möte",
      "yes": "Ja",
      "no": "Nej",
      "minutes": "minuter",
      "reschedule-all-future-occurrences": "Omfördela alla framtida händelser",
      "cancel-all-future-occurrences": "Avbryt alla framtida händelser",
      "appointment-repeat": "Detta möte kommer att upprepas",
      "daily": "dagligen",
      "weekly": "varje vecka",
      "monthly": "en gång i månaden",
      "yearly": "årlig",
      "on-weekday": "på {{weekday}}",
      "x-times": "{{count}} gånger",
      "indefinitely": "obegränsat",
      "next-x-occurrences": "nästa {{count}} händelser:",
      "thank-you-customer": "Tack {{name}}!",
      "appointment-cancelled": "Ditt möte har blivit avbrutet.",
      "confirmation-sent": "Vi har skickat dig ett bekräftelsemail.",
      "next-month": "nästa månad",
      "previous-month": "förra månaden",
      "other": "Övrig",
      "street-address": "adress",
      "apt-unit": "lägenhet",
      "zip-code": "postnummer",
    }
  },
  // Greek, Modern
  "el": {
    "translations": {
      "step": "βήμα {{step}}.",
      "timezone": "ζώνη ώρας",
      "to": "μέχρι",
      "time-timezone": "χρόνος: {{timezone}}",
      "continue": "να συνεχίσει",
      "change": "αλλαγή",
      "mobile-phone-placeholder": "Αριθμός κινητού τηλεφώνου",
      "business-local-time": "επιχειρηματική τοπική ώρα",
      "back-to-day-selection": "πίσω στην επιλογή της ημέρας",
      "your-selection": "την επιλογή σας",
      "confirm-booking": "πατήστε για επιβεβαίωση ραντεβού",
      "request-booking": "κάντε κλικ για να ζητήσετε ραντεβού",
      "confirm-reschedule": "πατήστε για να προγραμματίσετε ξανά το ραντεβού",
      "add-to-calendar": "προσθέστε στο {{calendar}}",
      "download-ics": "λήψη αρχείου",
      "ok": "Εντάξει",
      "your-appointment-engine": "τη μηχανή ραντεβού σας",
      "next-week": "την επόμενη εβδομάδα",
      "previous-week": "προηγούμενη εβδομάδα",
      "staff": "μέλος του προσωπικού",
      "privacy-policy": "Πολιτική απορρήτου",
      "no-preference": "Καμία προτίμηση",
      "greeting": "Γεια σου {{name}}",
      "appointment-found": "Βρήκαμε ένα ραντεβού στις {{date}} στις {{time}}",
      "what-to-do": "Τι θα ήθελες να κάνεις?",
      "reschedule": "Προγραμματισμός ραντεβού",
      "cancel-appointment": "Ακύρωση ραντεβού",
      "yes": "Ναι",
      "no": "όχι",
      "minutes": "λεπτά",
      "reschedule-all-future-occurrences": "Προγραμματίστε όλα τα μελλοντικά συμβάντα",
      "cancel-all-future-occurrences": "Ακύρωση όλων των μελλοντικών συμβάντων",
      "appointment-repeat": "Αυτό το ραντεβού θα επαναληφθεί",
      "daily": "καθημερινά",
      "weekly": "εβδομαδιαίος",
      "monthly": "μηνιαίος",
      "yearly": "ετήσια",
      "on-weekday": "τις {{weekday}}",
      "x-times": "{{count}} times",
      "indefinitely": "επ 'αόριστον",
      "next-x-occurrences": "τα επόμενα {{count}} συμβάντα:",
      "thank-you-customer": "Σας ευχαριστώ {{name}}!",
      "appointment-cancelled": "Το ραντεβού σας ακυρώθηκε.",
      "confirmation-sent": "Σας έχουμε στείλει ένα email επιβεβαίωσης.",
      "next-month": "τον επόμενο μήνα",
      "previous-month": "προηγούμενος μήνας",
      "other": "Αλλα",
      "street-address": "διεύθυνση",
      "apt-unit": "διαμέρισμα",
      "zip-code": "ΤΑΧΥΔΡΟΜΙΚΟΣ ΚΩΔΙΚΟΣ",
    }
  },
  // Hungarian
  "hu": {
    "translations": {
      "step": "lépés {{step}}.",
      "timezone": "időzóna",
      "to": "-",
      "time-timezone": "időzóna: {{timezone}}",
      "continue": "Folytatás",
      "change": "Módosítom",
      "mobile-phone-placeholder": "mobiltelefon szám",
      "business-local-time": "üzleti helyi idő szerint",
      "back-to-day-selection": "vissza a nap kiválasztáshoz",
      "your-selection": "A kiválasztott időpont",
      "confirm-booking": "A találkozó megerősítése",
      "request-booking": "kattintson a találkozó kérésére",
      "confirm-reschedule": "A találkozó megerősítése",
      "add-to-calendar": "Add hozzá: {{calendar}}",
      "download-ics": "fájl letöltése",
      "ok": "ok",
      "your-appointment-engine": "a kinevezés motorját",
      "next-week": "kővetkező hét",
      "previous-week": "előző hét",
      "staff": "munkatárs",
      "privacy-policy": "Adatvédelmi irányelvek",
      "no-preference": "Nincs előny",
      "greeting": "Helló {{name}}!",
      "appointment-found": "Találtunk egy találkozót a {{date}} -en {{time}}",
      "what-to-do": "Mit szeretnél csinálni?",
      "reschedule": "Találkozó újratervezése",
      "cancel-appointment": "A találkozó megszakítása",
      "yes": "Igen",
      "no": "nem",
      "minutes": "perc",
      "reschedule-all-future-occurrences": "Minden jövőbeni esemény átcsomagolása",
      "cancel-all-future-occurrences": "Az összes jövőbeli esemény megszakítása",
      "appointment-repeat": "Ez a találkozó ismétlődik",
      "daily": "napi",
      "weekly": "heti",
      "monthly": "havi",
      "yearly": "évi",
      "on-weekday": "{{weekday}}",
      "x-times": "{{count}}-szer",
      "indefinitely": "végtelenségig",
      "next-x-occurrences": "következő {{count}} előfordulás:",
      "thank-you-customer": "Köszönöm {{name}}!",
      "appointment-cancelled": "A találkozót törölték.",
      "confirmation-sent": "Elküldtünk Önnek egy megerősítő e-mailt.",
      "next-month": "következő hónap",
      "previous-month": "előző hónap",
      "other": "Egyéb",
      "street-address": "cím",
      "apt-unit": "apartman",
      "zip-code": "irányítószámot",
    }
  },
  // Hebrew
  "iw": {
    "translations": {
      "step": ".{{step}} צעד",
      "timezone": "איזור זמן",
      "to": "-",
      "time-timezone": "{{timezone}} שעון",
      "continue": "להמשיך",
      "change": "לשנות",
      "mobile-phone-placeholder": "טלפון נייד",
      "business-local-time": "זמני פתיחה",
      "back-to-day-selection": "חזרה לבחירת יום",
      "your-selection": "הנה מה שבחרת",
      "confirm-booking": "נא ללחוץ לאישור פגישה",
      "request-booking": "לחץ כדי לבקש פגישה",
      "confirm-reschedule": "נא ללחוץ לקבוע זמן חדש",
      "add-to-calendar": "הוסיף אל {{calendar}}",
      "download-ics": "הורדה של קובץ ICS",
      "ok": "בחר",
      "your-appointment-engine": "מנוע הבוקינג שלך",
      "next-week": "שבוע הבא",
      "previous-week": "שבוע קודם",
      "staff": "חברי צוות",
      "privacy-policy": "מדיניות פרטיות",
      "no-preference": "אין העדפות",
      "greeting": "{{name}} שלום",
      "appointment-found": "{{time}} בשעה {{date}} מצאנו פגישה שנקבעה ל",
      "what-to-do": "מה ברצונך לעשות?",
      "reschedule": "לקבוע זמן חדש",
      "cancel-appointment": "ביטול",
      "yes": "כן",
      "no": "לא",
      "minutes": "דקות",
      "reschedule-all-future-occurrences": "קבע מחדש את כל המופעים העתידיים",
      "cancel-all-future-occurrences": "בטל את כל המופעים העתידיים",
      "appointment-repeat": "מינוי זה יחזור",
      "daily": "יומי",
      "weekly": "שבועי",
      "monthly": "חודשי",
      "yearly": "שנתי",
      "on-weekday": "{{weekday}}",
      "x-times": "{{count}} פעמים",
      "indefinitely": "הגבלת זמן",
      "next-x-occurrences": "{{count}} המופעים הבאים:",
      "thank-you-customer": "!תודה לך {{name}}",
      "appointment-cancelled": "הפגישה שלך בוטלה.",
      "confirmation-sent": "שלחנו לך אימייל עם הפרטים ועם לינק למקרה שצריך לשנות תאריך או לבטל",
      "next-month": "חודש הבא",
      "previous-month": "חודש שעבר",
      "other": "אַחֵר",
      "street-address": "כתובת",
      "apt-unit": "דִירָה",
      "zip-code": "מיקוד",
    }
  },
  // Romanian
  "ro": {
    "translations": {
      "step": "Etapa {{step}}.",
      "timezone": "Fus orar",
      "to": "de la ora",
      "time-timezone": "Fus orar: {{timezone}}",
      "continue": "Continuă",
      "change": "Modifică",
      "mobile-phone-placeholder": "numar de telefon mobil",
      "business-local-time": "timp local de afaceri",
      "back-to-day-selection": "înapoi la selecția zilei",
      "your-selection": "Alegerea ta",
      "confirm-booking": "Click pentru a confirma întâlnirea",
      "request-booking": "Click pentru a solicita o programare",
      "confirm-reschedule": "Click pentru a reprograma întâlnirea",
      "add-to-calendar": "Adaugă la {{calendar}}",
      "download-ics": "Descarcă fișier .ics",
      "ok": "ok",
      "your-appointment-engine": "motorul de numire",
      "next-week": "saptamana viitoare",
      "previous-week": "saptamana trecuta",
      "staff": "Consultantul tău",
      "privacy-policy": "Politica de confidentialitate",
      "no-preference": "Nici o preferință",
      "greeting": "Bună ziua {{name}}!",
      "appointment-found": "Am găsit o întâlnire la {{date}} la {{time}}",
      "what-to-do": "Ce ai vrea sa faci?",
      "reschedule": "Reprogrameaza intalnirea ",
      "cancel-appointment": "Anulați numirea",
      "yes": "Da",
      "no": "Nu",
      "minutes": "de minute",
      "reschedule-all-future-occurrences": "Reschedule toate evenimentele viitoare",
      "cancel-all-future-occurrences": "Anulați toate evenimentele viitoare",
      "appointment-repeat": "Această întâlnire se va repeta",
      "daily": "zilnic",
      "weekly": "săptămânal",
      "monthly": "lunar",
      "yearly": "anual",
      "on-weekday": "în zilele de {{weekday}}",
      "x-times": "{{count}} ori",
      "indefinitely": "pe termen nelimitat",
      "next-x-occurrences": "Următoarele {{count}} apariții:",
      "thank-you-customer": "Mulțumesc lui {{name}}!",
      "appointment-cancelled": "Numirea dvs. a fost anulată.",
      "confirmation-sent": "V-am trimis un e-mail de confirmare.",
      "next-month": "luna viitoare",
      "previous-month": "luna trecută",
      "other": "Alte",
      "street-address": "abordare",
      "apt-unit": "apartament",
      "zip-code": "cod poștal",
    }
  },
  // Indonesian
  "id": {
    "translations": {
      "step": "Langkah {{step}}.",
      "timezone": "Zona waktu:",
      "to": "sampai",
      "time-timezone": "waktu {{timezone}}",
      "continue": "terus",
      "change": "perubahan",
      "mobile-phone-placeholder": "Nomor ponsel",
      "business-local-time": "Waktu lokal bisnis",
      "back-to-day-selection": "Kembali ke seleksi hari",
      "your-selection": "Pilihan Anda",
      "confirm-booking": "tekan untuk mengkonfirmasi janji",
      "request-booking": "klik untuk meminta janji",
      "confirm-reschedule": "tekan untuk menjadwalkan ulang janji temu",
      "add-to-calendar": "Tambahkan ke {{ calendar }}",
      "download-ics": "Unduh file ICS",
      "ok": "baik",
      "your-appointment-engine": "Mesin penunjukan Anda",
      "next-week": "minggu depan",
      "previous-week": "minggu sebelumnya",
      "staff": "anggota staff",
      "privacy-policy": "Kebijakan pribadi",
      "no-preference": "Tidak ada preferensi",
      "greeting": "Halo {{name}}",
      "appointment-found": "Kami telah menemukan janji temu di {{date}} di {{time}}",
      "what-to-do": "Apa yang ingin kamu lakukan?",
      "reschedule": "Jadwal ulang pertemuan",
      "cancel-appointment": "Batalkan janji",
      "yes": "Ya",
      "no": "Tidak",
      "minutes": "menit",
      "reschedule-all-future-occurrences": "Jadwalkan semua kejadian di masa mendatang",
      "cancel-all-future-occurrences": "Batalkan semua kejadian di masa mendatang",
      "appointment-repeat": "Penunjukan ini akan berulang",
      "daily": "harian",
      "weekly": "mingguan",
      "monthly": "bulanan",
      "yearly": "tahunan",
      "on-weekday": "pada hari {{weekday}}",
      "x-times": "{{count}} Kali",
      "indefinitely": "tanpa batas",
      "next-x-occurrences": "{{count}} kejadian berikutnya:",
      "thank-you-customer": "{{name}} terima kasih!",
      "appointment-cancelled": "Janji temu Anda telah dibatalkan.",
      "confirmation-sent": "Kami telah mengirimi Anda email konfirmasi.",
      "next-month": "bulan depan",
      "previous-month": "bulan sebelumnya",
      "other": "Lain",
      "street-address": "alamat",
      "apt-unit": "Apartemen",
      "zip-code": "Kode Pos",
    }
  },
  // Norwegian (Bokmål)
  "nn": {
    "translations": {
      "step": "Steg {{step}}.",
      "timezone": "Tidssone:",
      "to": "til",
      "time-timezone": "{{timezone}} tid",
      "continue": "fortsett",
      "change": "endre",
      "mobile-phone-placeholder": "Mobile phone number",
      "business-local-time": "Forretnings lokal tid",
      "back-to-day-selection": "Tilbake til valg av dag",
      "your-selection": "Ditt valg",
      "confirm-booking": "trykk for å bekrefte avtalen",
      "request-booking": "trykk for å be om avtale",
      "confirm-reschedule": "trykk for å omorganisere avtalen",
      "add-to-calendar": "Legg til i {{ calendar }}",
      "download-ics": "Last ned ICS-filen",
      "ok": "ok",
      "your-appointment-engine": "Din avtale motor",
      "next-week": "neste uke",
      "previous-week": "forrige uke",
      "staff": "betjeningen",
      "privacy-policy": "Personvernregler",
      "no-preference": "Ingen preferanse",
      "greeting": "Hei {{name}}!",
      "appointment-found": "Vi har funnet en avtale på {{date}} kl. {{time}}",
      "what-to-do": "Hva har du lyst til å gjøre?",
      "reschedule": "Endre avtale",
      "cancel-appointment": "Avlys avtale",
      "yes": "Ja",
      "no": "Nei",
      "minutes": "minutter",
      "reschedule-all-future-occurrences": "Reschedule alle fremtidige hendelser",
      "cancel-all-future-occurrences": "Avbryt alle fremtidige hendelser",
      "appointment-repeat": "Denne avtalen vil gjenta",
      "daily": "daglig",
      "weekly": "ukentlig",
      "monthly": "månedlig",
      "yearly": "årlig",
      "on-weekday": "på {{weekday}}",
      "x-times": "{{count}} ganger",
      "indefinitely": "på ubestemt tid",
      "next-x-occurrences": "Neste {{count}} hendelser:",
      "thank-you-customer": "Takk {{name}}!",
      "appointment-cancelled": "Avtalen din er kansellert.",
      "confirmation-sent": "Vi har sendt deg en bekreftelses-epost.",
      "next-month": "neste måned",
      "previous-month": "forrige måned",
      "other": "Annen",
      "street-address": "adresse",
      "apt-unit": "leilighet",
      "zip-code": "postnummer",
    },
  },
  // Slovenian
  "sl": {
    "translations": {
      "step": "Korak {{step}}.",
      "timezone": "Časovni pas:",
      "to": "do",
      "time-timezone": "{{timezone}} čas",
      "continue": "nadaljuj",
      "change": "sprememba",
      "mobile-phone-placeholder": "Številka mobilnega telefona",
      "business-local-time": "Lokalni čas poslovanja",
      "back-to-day-selection": "Nazaj na izbiro datuma",
      "your-selection": "Vaš izbor",
      "confirm-booking": "pritisnite, da potrdite sestanek",
      "request-booking": "kliknite, če želite zahtevati sestanek",
      "confirm-reschedule": "pritisnite, da prerazporedite imenovanje",
      "add-to-calendar": "Dodaj v {{ calendar }}",
      "download-ics": "Prenesite datoteko ICS",
      "ok": "ok",
      "your-appointment-engine": "Vaš motor rezervacij",
      "next-week": "naslednji teden",
      "previous-week": "prejšnji teden",
      "staff": "Osebje",
      "privacy-policy": "Obvestilo o zbiranju zasebnosti",
      "no-preference": "Vseeno",
      "greeting": "Pozdravljeni {{name}}!",
      "appointment-found": "Našli smo sestanek na dan {{date}} ob {{time}}",
      "what-to-do": "Kaj bi rad počel?",
      "reschedule": "Prestavite imenovanje",
      "cancel-appointment": "Prekliči sestanek",
      "yes": "Ja",
      "no": "Ne",
      "minutes": "minut",
      "reschedule-all-future-occurrences": "Prestavite vse prihodnje dogodke",
      "cancel-all-future-occurrences": "Prekliči vse prihodnje dogodke",
      "appointment-repeat": "To imenovanje se bo ponovilo",
      "daily": "dnevno",
      "weekly": "tedensko",
      "monthly": "mesečno",
      "yearly": "letno",
      "on-weekday": "ob {{weekday}}",
      "x-times": "{{count}}-krat",
      "indefinitely": "za nedoločen čas",
      "next-x-occurrences": "Naslednjih {{count}} pojavov:",
      "thank-you-customer": "Hvala {{name}}!",
      "appointment-cancelled": "Vaš sestanek je preklican.",
      "confirmation-sent": "Poslali smo vam potrditveno e-poštno sporočilo.",
      "next-month": "naslednji mesec",
      "previous-month": "prejšnji mesec",
      "other": "Drugo",
      "street-address": "adresa",
      "apt-unit": "apartma",
      "zip-code": "poštna številka",
    },
  },
}
